import { withChartLayout } from 'components/common';
import AlcoholScreen from 'components/features/chart/admission-history/alcohol-screen/AlcoholScreen';

const AlcoholScreenPage = withChartLayout('Alcohol Screen')(AlcoholScreen);
export default AlcoholScreenPage;
